module.exports = __webpack_public_path__ + "static/media/jail.c4eb1e7b.mp3";